import { v4 as uuidV4 } from 'uuid';
import { useLocalizationContext } from '@im/react-localization';
import { useSearchParams } from 'react-router-dom';
import { useAccount, useMsalAuthentication } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
import { AuthRequest, DefaultAuthInteractionType } from '../auth/AuthRequest';
import { useBuildVars, sessionId } from '../config';

export type ExtraHeaders = { [headerName: string]: string | undefined };

export function useApiHeaders() {
  const [searchParams] = useSearchParams();
  const buildVars = useBuildVars();
  const l10nContext = useLocalizationContext();
  const { acquireToken } = useMsalAuthentication(
    InteractionType.Silent,
    AuthRequest
  );
  const userName = useAccount()?.username ?? '';

  return (extraHeaders?: ExtraHeaders, requireResellerId = false) =>
    acquireToken(DefaultAuthInteractionType).then((result) => {
      const correlationId = uuidV4();
      const { locale } = l10nContext;
      const countryCode =
        searchParams.get('countryCode') ?? locale.split('-')[1];
      const companyCode = searchParams.get('companyCode');
      const imEnvironment = buildVars.IM_ENVIRONMENT;

      let resellerIdHeader = undefined;
      if (requireResellerId) {
        const resellerId = searchParams.get('resellerId');
        if (!resellerId) throw new Error('Missing Reseller ID');
        resellerIdHeader = { 'IM-ResellerID': resellerId };
      }

      const userId = searchParams.get('userId') ?? '';

      return {
        Accept: 'application/json',
        'Accept-Language': locale, // en-US
        Authorization: `Bearer ${result?.accessToken}`,
        'Content-Type': 'application/json',
        'IM-AcceptLanguage': locale, // en-US [deprecated-soon]
        'IM-CompanyCode': companyCode,
        'IM-CorrelationID': correlationId,
        'IM-CountryCode': countryCode, // US
        'IM-DDSessionId': sessionId, // session_id used for throttling rate limit for no-auth
        'IM-Environment': imEnvironment,
        'IM-MicroFrontendID': 'gds',
        'IM-Operation': '',
        'IM-SenderID': 'IMAEP',
        'IM-UserID': userId,
        'IM-UserName': userName,
        ...resellerIdHeader,
        ...extraHeaders,
      } as { [headerName: string]: string };
    });
}
